import { TextExposedField } from "nystem-components";

const EmailExposedField = (props) => <TextExposedField {...props} />;
export default EmailExposedField;
